<template>
  <div class="w-full h-full">
    <div class="pt-1">
      <div class="text-center">
        <div class="my-3">
          <LayupIcon class="my-3" />
          <h5 class="h5 text-lg text-gray-700 font-semibold">Create New Password</h5>
          <p v-if="errorMessage" class="text-red-700">{{ errorMessage }}</p>
        </div>
      </div>

      <PasswordInput v-model="form.password" :disabled="isLoading" :label="`Enter Password`" class="text-left" />

      <PasswordInput v-model="confirmPassword" :disabled="isLoading" :label="`Confirm Password`" class="text-left" />

      <LayupButton
        type="submit"
        :disabled="isLoading"
        data-testid="submit"
        :isLoading="isLoading"
        :label="'Submit'"
        @click="onSubmit()"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import LayupButton from '@/components/common/LayupButton.vue';
import PasswordInput from '@/components/common/PasswordInput.vue';
import LayupIcon from '@/components/icons/LayupIcon.vue';
import { NetworkError } from '@/errors';
import { getErrorMessage } from '@/services/auth';
import { updateUser } from '@/services/user';
import { useUserStore } from '@/stores/users';
import { isValidPassword } from '@/utils/form.utils';
import { addMetric, createException, createWarning } from '@/utils/monitoring.utils';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const userStore = useUserStore();

const router = useRouter();
const errorMessage = ref('');
const isLoading = ref(false);

const form = {
  cellNumber: '',
  password: '',
};

const confirmPassword = ref('');

const onSubmit = async () => {
  try {
    errorMessage.value = '';
    const passwordValidation = isValidPassword(form.password, confirmPassword.value);
    if (!passwordValidation.isValid) {
      errorMessage.value = passwordValidation.errorMessage;
    } else {
      await updateUser(userStore.user._id!, { password: form.password });
      addMetric('create_password', { status: 'success', channel: 'widget' });
      await router.replace({ name: 'WidgetSignIn' });
    }
  } catch (error: any) {
    if (error instanceof NetworkError) {
      createWarning(error);
      addMetric('create_password', { status: 'network_error', channel: 'widget' });
      errorMessage.value = 'Network Error. Please try again.';
    } else {
      createException(error);
      addMetric('create_password', { status: 'error', channel: 'widget' });
      errorMessage.value = getErrorMessage(error);
    }
  } finally {
    isLoading.value = false;
  }
};
</script>
